module.exports = __webpack_public_path__ + "img/Marketing_case_pic03.b443d8c5.png";